import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Paper } from "@mui/material";
import { TableContainer } from "@mui/material";
import { TableBody, TableCell, TableRow } from "@mui/material";
import { StyledTableCell, StyledTableHead, } from "../../../Styles/tabelCellStyled/customTableCell";
import { CustomThemeProvider, } from "../../../Styles/theme/customThemeprovider";
import { IIntensidadeProdutiva, IProducao_forrageira, } from "../../../Interfaces/eficiencia_alimentar/plano_de_alimentacao";
import { get } from "../../../Services/tokenConfig";
import { func_print } from "../../../Func_genericas/func_print";
import LoadingVulpes from "../../../Styles/Loader/loading";
import { AuthContext } from "../../../AuthContext/AuthContext";
import { formatarNumero_recebido_com_casa_decimais } from "../../../Func_genericas/formatar_numero_formato_pt";

interface IProducaoProps {
  tabela: IIntensidadeProdutiva | undefined;
  setTabela: React.Dispatch<React.SetStateAction<IIntensidadeProdutiva | undefined>>;
  tabela_producao: IProducao_forrageira | undefined;
  total_cn_from_tabela_necessidades_arg: number;
}

export const IntensividadeProdutiva: React.FC<IProducaoProps> = ({
  tabela,
  setTabela,
}) => {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const auth = useContext(AuthContext);


  async function getTabela() {
    try {
      setIsLoading(true);
      let res = await get(auth.token.cookie_token, `/get_Intensidade_Produtiva_id_rosto/${location.state.id_identificacao}`);
      if (res.status === 200) {
        setTabela(res.data.result[0]);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("getExtra", error, true);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    (async () => {
      await getTabela();
    })();
  }, []);



  return (
    <>
      {isLoading ?
        <LoadingVulpes /> :
        <CustomThemeProvider>
          <TableContainer
            component={Paper}
            variant="outlined"
            sx={{
              height: "auto",
              width: "auto",
              margin: 2,
              padding: 2,
            }}
          >
            <table style={{ width: "50%" }}>
              <TableBody>

                <TableRow>
                  <TableCell
                    colSpan={2}
                    sx={{
                      fontWeight: 600,
                      fontSize: 14,
                      fontFamily: "candara",
                    }}
                  >
                    2.2 Intensidade Produtiva (CN/ ha de superficie
                    forrageira)
                  </TableCell>
                  <StyledTableCell sx={{ backgroundColor: "lightgrey" }}> {tabela?.cn_ha === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.cn_ha)} </StyledTableCell>

                </TableRow>
                <TableRow>
                  <TableCell sx={{ display: "flex", justifyContent: "right" }} >
                    CN
                  </TableCell >
                  <StyledTableHead sx={{ minWidth: 120, backgroundColor: "lightgrey" }}>{tabela?.cn === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.cn)}
                  </StyledTableHead>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ display: "flex", justifyContent: "right" }} >
                    Superficie forrageira
                  </TableCell>
                  <StyledTableHead sx={{ backgroundColor: "lightgrey" }}>{tabela?.superfici === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.superfici)} </StyledTableHead>
                </TableRow>
              </TableBody>
            </table>
          </TableContainer>
        </CustomThemeProvider>
      }
    </>
  );
};
